import { userLoginApi } from "../../api/user/userLoginApi"
import { userSelfGetService } from "./userSelfGetService"

export async function userAuthService(payload: { mobileNo: string; password: string }) {
	const { token } = await userLoginApi(payload)
	const { user, company } = await userSelfGetService(token)
	return { token, user, company }
}
